/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/refresh'
export default icon
